module.exports = __webpack_public_path__ + "a7df503838535406ee6aac074186b479.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-light.ttf
// module id = 87
// module chunks = 0